import React, {useContext, useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {Button, Form, Typography} from 'antd';
import PropTypes from 'prop-types';
import './application.scss';
import ApplicationTemplate from "../../components/applicationTemplate/applicationTemplate";

import {template} from "../../apis/application";
import {replaceUrlByParams} from "../../utils/api";
import {AppContext} from "../../App";
import {PAGE} from "../../utils/constants";

ApplicationPage.propTypes = {
    location: PropTypes.object,
    state: PropTypes.object,
    submitData: PropTypes.object,
};

function ApplicationPage(props) {
    let history = useHistory();
    const {pid} = useParams();
    const {Title} = Typography
    const [q, setQ] = useState([])
    const {appSetting, setLoading} = useContext(AppContext)
    const [form] = Form.useForm();
    const formValue = props.location.state ? props.location.state.formValue : []

    useEffect(() => {
        getApplicationTemplate();
        form.setFieldsValue(formValue);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getApplicationTemplate = async () => {
        setLoading(true)
        try {
            const res = await template(pid);
            if (res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setQ(res)
            }
        } catch (e) {
            console.error(e);
        }finally {
            setLoading(false)
        }
    };

    const questionMap = q.reduce((acc, section) => {
        let choice = {}

        section.format.forEach(format => {
            choice = {
                ...choice,
                [format.id]: format.name
            }

            if (format.choices) {
                format.choices.forEach(c => {
                    choice = {
                        ...choice,
                        [c.id]: c.name
                    }
                })
            }
        })

        if (section.choices) {
            section.choices.forEach(c => {
                choice = {
                    ...choice,
                    [c.id]: c.name
                }
            })
        }

        return {
            ...acc,
            [section.id]: {
                title: section.title,
                type: section.type,
                description: section.description
            },
            ...choice
        }
    }, {})

    const onFinish = async (value) => {
        value = Object.keys(value).filter( e => value[e] !== undefined).reduce((acc, curr) => { //filter unless key
            return {
                ...acc,
                [curr]: value[curr]
            }
        }, {})

        const valueToPreview = q.map( (section) => {
            return {
                id: section.id,
                title: section.title,
                type: section.type,
                description: section.description,
                application: Object.keys(value[section.id]).map((field) => {
                  if(section.type === 'optionalMultipleChoice') {
                      return {
                          name: questionMap[field],
                          choices: Object.keys(value[section.id][field]).map((choice) => {
                              return {
                                  name: questionMap[choice],
                                  value: questionMap[value[section.id][field][choice]]
                              }
                          })
                      }
                  }else {
                      return {
                          name: questionMap[field],
                          value: questionMap[value[section.id][field]] ? questionMap[value[section.id][field]] : value[section.id][field]
                      }
                  }
                })

            }
        }, {})

        history.push({ //to preview mode
            pathname: `${replaceUrlByParams(PAGE.APPLICATION_CONFIRM, {':pid':pid})}`,
            state: { formValue: value, previewValue: valueToPreview }
        });
    };

    const onFinishFailed = errorInfo => {
        // console.log('Failed:', errorInfo);
    };

    return (
        <div className='application-page'>
            <Title className='title' level={3}>{appSetting.title} 報名表格</Title>
            <Form
                form={form}
                scrollToFirstError={true}
                layout='vertical'
                labelAlign='left'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <ApplicationTemplate
                    template={q}
                    form={form}
                />

                <div className='button-container'>
                    <Button onClick={()=> history.push(`${replaceUrlByParams(PAGE.LANDING,{':pid':pid})}`)}>
                        返回
                    </Button>

                    <Button type="primary" htmlType="submit">
                        報名
                    </Button>
                </div>
            </Form>

        </div>
    )
}

export default ApplicationPage;
